import { Modal, ModalProps } from 'antd';

export default function PlayedGameModal({ modalData }: { modalData: ModalProps }) {
  return <Modal {...modalData} title="상세 게임 플레이 내역" okText="확인" cancelText="취소" />;
}
